import { AccessPermission } from '../../../api/accessApi';

interface ToolPickerProps {
  permissions: AccessPermission[];
  /** Permission names the signed-in user may grant. */
  grantable: string[];
  /** Tools already given by something else (the role, or the department): shown ticked and locked. */
  inherited: Set<string>;
  draft: Set<string>;
  onToggle: (name: string) => void;
}

/** Checklist of every section and tool, grouped by section. */
export default function ToolPicker({ permissions, grantable, inherited, draft, onToggle }: ToolPickerProps) {
  const toolPerms = permissions.filter((p) => p.kind === 'tool' || p.kind === 'section');
  const sections = toolPerms.filter((p) => p.kind === 'section').sort((a, b) => a.order - b.order);

  return (
    <div className="acc-tool-grid">
      {sections.map((section) => {
        const sectionOn = inherited.has(section.name) || draft.has(section.name);
        const tools = toolPerms.filter((p) => p.kind === 'tool' && p.section === section.section);
        const box = (p: AccessPermission, covered: boolean, all = false) => {
          const locked = covered || inherited.has(p.name) || !grantable.includes(p.name);
          return (
            <label key={p.name} className={`acc-tool-row${all ? ' all' : ''}${locked ? ' locked' : ''}`}>
              <input
                type="checkbox"
                checked={covered || inherited.has(p.name) || draft.has(p.name)}
                disabled={locked}
                onChange={() => onToggle(p.name)}
              />
              <span>{all ? `All ${section.label}` : p.label}</span>
            </label>
          );
        };
        return (
          <div key={section.name} className="acc-tool-section">
            <h4>{section.label}</h4>
            {box(section, false, true)}
            {tools.map((t) => box(t, sectionOn))}
          </div>
        );
      })}
    </div>
  );
}
